import {
  LIST_REPORT5,
  LIST_REPORT5_SUCCESS,
  LIST_REPORT5_CLEAN,
  LIST_REPORT5_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  report: [],
}

const Report5List = (state = initialState, action) => {
  switch (action.type) {
    case LIST_REPORT5:
      state = {
        ...state,
        loading: true,
      }
      break
    case LIST_REPORT5_SUCCESS:
      state = {
        ...state,
        report: action.payload.report,
        loading: false,
        done: true,
      }
      break
    case LIST_REPORT5_CLEAN:
      state = initialState
      break
    case LIST_REPORT5_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default Report5List
